<template>
    <el-dialog title="请绑定Google验证码" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">
        <div v-show="showBind">
            <qrcode :value="qrCodeUrl" :options="{ width: 240 }"></qrcode>
        </div>

        <div v-show="showBind">
            <el-form :model="form" :rules="rules" ref="form">

                <el-form-item
                    prop="tmpCode"
                >
                    <el-input
                        v-model="form.tmpCode"
                        autocomplete="off"
                        placeholder="请输一组验证码"
                        style="width: 240px"
                    ></el-input>
                </el-form-item>

            </el-form>

            <h4>请使用 Google Authenticator 扫描二维码增加两步验证，以保证账户资金安全</h4>
            <el-button type="info" @click="notBind">暂不绑定</el-button>

            <el-button type="success" @click="bindAuthConfirm">绑定</el-button>
        </div>

    </el-dialog>
</template>

<script>

    import md5 from 'js-md5';

    export default {
        name: "BindAuthCode",
        props: {
            show: Boolean,
            formData: Object,
            action: String
        },
        data() {
            return {
                dialogShow: this.show,
                qrCodeUrl: "",
                showBind: false,
                showAlreadyBind: true,
                form:{
                    tmpCode: "",
                },
                rules: {
                    tmpCode: [
                    { required: true, message: '请输入6个数字验证码', trigger: 'blur' },
                    { min: 6, max: 6, message: '请输入6个数字验证码', trigger: 'blur' },
                    ]
                }
            }
 
        },
        methods: {
            openDialog() {
                this.getAuthCode();
            },
            closeDialog() {
                this.dialogShow = false;
                this.$emit('update:show', false);
            },

            getAuthCode() {
                this.axios.post("/merchant/getAuthCode", {}).then(res => {
                    if (res.code === 200) {
                        var data = res.data;
                        if (data) {
                            if (!data.bind) {
                                this.showBind = true;
                                this.qrCodeUrl = data.qrCode;
                            }else{
                                this.showBind = false;
                                this.showAlreadyBind = true;
                            }
                        }

                    } else {

                        this.$notify.error({
                            title: '请求二维码失败',
                            message: res.msg,
                        });
                    }
                })
            },

            bindAuthConfirm() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.axios.post("/merchant/bindAuthConfirm", {
                            code: this.form.tmpCode
                        }).then(res => {
                            if (res.code === 200) {
                                this.showBind = false;
                                this.showAlreadyBind = true;
                                
                                this.dialogShow = false;
                                this.$emit('update:show', false);
                            }
                        })
                    } else{
                        return false;
                    }   
                })
            },
            notBind() {
                this.axios.post("/merchant/notBindAuth", {
                            code: this.form.tmpCode
                    }).then(res => {
                        if (res.code === 200) {
                            this.showBind = false;
                            this.showAlreadyBind = true;
                            
                            this.dialogShow = false;
                            this.$emit('update:show', false);
                        }
                })
            },

        },
        watch: {
            show(newVal) {
                this.dialogShow = newVal;
            }
        },
    }
</script>

<style scoped>

</style>